import { ReadonlyVec3, vec3 } from 'gl-matrix';
import { CSSProperties } from 'react';
import {
    DvfGeometry,
    DvfPlaneLattice,
    dvfPlaneLattice,
} from '~/domain/dvf/dvfField';
import { PlaneView } from '~/engine/view/views/PlaneView';

export const PLANE_OVERLAY_REDRAW_EVENTS: readonly string[] = [
    'planeIntersectionPointChanged',
    'zoomScaleChanged',
    'viewPositionChanged',
];

export const PLANE_OVERLAY_CANVAS_STYLE: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
};

export function planeLattice(
    view: PlaneView,
    geometry: DvfGeometry,
    spacingMm: number,
    extent: { min: ReadonlyVec3; max: ReadonlyVec3 }
): DvfPlaneLattice {
    // planeCoordinates is the plane's signed distance along the unit view direction.
    const planePoint = vec3.scale(
        vec3.create(),
        view.viewDirection,
        view.planeCoordinates
    );
    return dvfPlaneLattice(
        geometry,
        spacingMm,
        planePoint,
        view.viewXDirection,
        view.viewYDirection,
        extent.min,
        extent.max
    );
}

export function clearPlaneCanvas(
    canvas: HTMLCanvasElement | null
): CanvasRenderingContext2D | null {
    const ctx = canvas?.getContext('2d');
    if (!canvas || !ctx) {
        return null;
    }
    const dpr = window.devicePixelRatio || 1;
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    const pw = Math.round(width * dpr);
    const ph = Math.round(height * dpr);
    if (canvas.width !== pw || canvas.height !== ph) {
        canvas.width = pw;
        canvas.height = ph;
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, width, height);
    return ctx;
}
